// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  offerDetails: Object,
};

const DeleteSelectedOffer = (props: Props) => {
  const {
    visible,
    close,
    submit,
    offerDetails,
  } = props;

  const deleteSelectedOffer = () => {
    submit(offerDetails && offerDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedOffer} type="danger">Deactivate</SpButton>,
      ]}
      title="Deactivate Offer"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to deactivate this coupon?</h6>
        <SpH5 className="pb-3">
          <div>{offerDetails && offerDetails.code}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedOffer;
